import LocalizedStrings from "react-localization"

import english_us from "./en_us"
import spanish_mx from "./es_mx"
import french_ca from "./fr_ca"
import { IStrings } from "./IStrings"

const strings: IStrings = new LocalizedStrings({
    en: english_us,
    es: spanish_mx,
    fr: french_ca
})

export default strings
